import { Col, Row } from "antd";
import React from "react";
import styled from "styled-components";

import { DesWorkHard } from "src/data/team";
import workHard from "src/assets/images/team/workHard.png";

const Wrapper = styled.section`
  text-align: center;
  .container {
    padding: 50px 0;
    //border-bottom: 2px solid #cecece;
  }
`;

const Title = styled.h4`
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
  color: white;
`;

const Description = styled.p`
  font-size: 20px;
  margin-bottom: 30px;
  color: white;
`;

const ImgWorkHard = styled.img`
  width: 100%;
`;

const WordHard: React.FC = () => {
  return (
    <Wrapper>
      <div className="container">
        <Row justify="center">
          <Col>
            <Title>Work Hard & Play Hard</Title>
            <Description>{DesWorkHard}</Description>
            <ImgWorkHard src={workHard} />
          </Col>
        </Row>
      </div>
    </Wrapper>
  );
};

export default WordHard;
